export default __webpack_public_path__ + "static/newsite-66f58391703af01d8b68889ee455b68d.png";